import type { GCampaignActionButtonProps } from './types';

import { LockIcon, PlayIcon } from '@shopify/polaris-icons';
import { usePricingModalMonitor } from '~/modules/pricing';
import { GButton, GTooltip } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { Button } from '@shopify/polaris';
import { ICampaignLocked } from './types';

interface GCampaignActionLockedProps {
  lockedStatus: ICampaignLocked;
  buttonProps?: GCampaignActionButtonProps;
}

export const GCampaignActionLocked = ({
  lockedStatus,
  buttonProps,
}: GCampaignActionLockedProps) => {
  const { t } = useTranslation();
  const { onOpenModalPricing } = usePricingModalMonitor();

  switch (lockedStatus) {
    case ICampaignLocked.BLOCKED_APP:
      return (
        <GButton
          {...buttonProps}
          icon={PlayIcon}
          {...(buttonProps?.isShowText
            ? { children: t('Complete billing to start') }
            : { tooltip: { content: t('Complete billing to start') } })}
          disabled
        />
      );

    case ICampaignLocked.REACHED_LIMIT:
    case ICampaignLocked.OVER_LIMIT:
      if (buttonProps?.isShowText)
        return (
          <Button icon={LockIcon} variant="primary" onClick={onOpenModalPricing}>
            {t('Upgrade to start')}
          </Button>
        );

      return (
        <div onClick={onOpenModalPricing}>
          <GTooltip width="wide" content={t('Upgrade to start')}>
            <Button variant="secondary" icon={LockIcon} onClick={onOpenModalPricing} />
          </GTooltip>
        </div>
      );

    default:
      return null;
  }
};
